export const HandleMaskPhoneNumber = (number) => {
    const mask = number.replace(/\D/g, '').match(/(\d{2})(\d{3})(\d{3})(\d{2})(\d{2})/);

    if (mask && mask[1] && mask[2] && mask[3] && mask[4] && mask[5]) {
        return (mask[1] === '38' ? '(' + mask[2] + ') ' : '+' + mask[1] + mask[2] + ' ') + mask[3] + ' ' + mask[4] + ' ' + mask[5];
    }

    return number;
};
